/**
 * ALL SIZES MUST BE EXPRESSED IN RELATIVE UNITS
 */

// #region General

// #region Breakpoints

export const DEFAULT_BREAKPOINTS = {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536
}

export const SAVED_ALBUMS_PAGE_DIVISION_BREAKPOINTS = {
    xs: 0,
    sm: 650
}

export const DETAILED_BREAKPOINTS = {
    xs: 0,
    xssm: 400,
    sm: 600,
    smmd: 775,
    md: 900,
    mdlg: 1080,
    lg: 1200,
    lgxl: 1350,
    xl: 1536
}

// #endregion Breakpoints

// #region Absolute position presets

export const DEFAULT_ABS_POSITION = "top-left";

export const ABS_POSITIONS = {
    top: "top",
    bottom: "bottom",

    left: "left",
    right: "right",

    topLeft: "top-left",
    topRight: "top-right",

    bottomLeft: "bottom-left",
    bottomRight: "bottom-right"
}

export const ABS_POSITION_STYLES = {
    "top": { top: 0, width: "100%" },
    "bottom": { bottom: 0, width: "100%" },

    "left": { left: 0, height: "100%" },
    "right": { right: 0, height: "100%" },

    "top-left": { top: 0, left: 0 },
    "top-right": { top: 0, right: 0 },

    "bottom-left": { bottom: 0, left: 0 },
    "bottom-right": { bottom: 0, right: 0 }
};

// #endregion Absolute position presets

// #endregion General

// #region Album list constants

export const ALBUM_GRID_COLUMN_GAP = '1.875rem';
export const ALBUM_GRID_ROW_GAP = '1.25rem';

// #region Filters constants

export const FILTER_ROW_XS_MAIN_LAYOUT_CLASS = {
    xs: 'ai-end',
    xssm: 'ai-center'
};
export const FILTER_ROW_XS_INPUT_LAYOUT_CLASS = {
    xs: 'flex-column jc-center',
    xssm: 'flex-row ai-center'
};

// #endregion Filters constants

// #endregion Album list constants

// #region Album item constants

export const ALBUM_COVER_SIZE_NO_UNIT = 5;
export const ALBUM_DETAILS_WIDTH_NO_UNIT = 12;
export const ALBUM_COVER_SIZE = `${ALBUM_COVER_SIZE_NO_UNIT}rem`;
export const ALBUM_DETAILS_WIDTH = `${ALBUM_DETAILS_WIDTH_NO_UNIT}rem`;

// #endregion Album item constants

// #region Random queue item constants

export const RANDOM_QUEUE_ITEM_MAX_WIDTH = {
    xs: '16rem',
    sm: '20rem',
    md: '25rem'
};

// #endregion Random queue item constants

// #region Top menu constants

export const TOP_MENU_PHANTOM_HEIGHT = {
    xs: '3.75rem',
    sm: '4.6875rem'
};

export const TOP_MENU_BUTTONS_SIZE = {
    xs: 'small',
    sm: 'medium'
};

// #endregion Top menu contants

// #region Player constants

export const PLAYER_PHANTOM_HEIGHT = {
    xs: '3.75rem',
    sm: '4.6875rem'
};

export const PLAYER_BUTTONS_SIZE = {
    xs: 'small',
    sm: 'medium'
};

// #endregion Player constants

// #region Playback info constants

export const PLAYBACK_INFO_CARD_HEIGHT = {
    xs: '2.5rem',
    sm: '3rem'
};

export const PLAYBACK_INFO_CONTENT_MAX_WIDTH = {
    xs: '8rem',
    sm: '10rem',
    md: '15rem'
};

/// It doesn't use unit specification
export const PLAYBACK_INFO_CAROUSEL_TEXT_MAX_WIDTH = {
    xs: '8',
    sm: '10',
    md: '12'
}

export const PLAYBACK_INFO_CONTENT_FLEX_GROW = {
    xs: '1',
    md: '0'
}

// #endregion Playback info constants

// #region User profile menu constants

export const USER_PROFILE_IMAGE_SIZES = {
    xs: '2rem',
    sm: '2.5rem'
};

// #endregion User profile menu constants

// #region Pager constants

export const PAGER_HEIGHT = '2rem';
export const PAGER_BUTTON_SIZE = {
    xs: '1.5rem',
    md: '2rem'
};
export const PAGER_BUTTONS_AROUND_CURRENT = {
    xs: 1,
    md: 2,
    xl: 3
};

// #endregion Pager constants

// #region Settings window constants

export const SETTINGS_WINDOW_HEIGHT = '80%';
export const SETTINGS_WINDOW_WIDTH = {
    xs: '90%',
    sm: '80%'
};
export const SETTINGS_WINDOW_PADDING = '2rem';

export const SETTINGS_WINDOW_BODY_LAYOUT_TITLE_CLASS = {
    xs: "flex-column gap-1",
    md: "flex-row gap-2"
};
export const SETTINGS_WINDOW_BODY_LAYOUT_INFO_CLASS = {
    xs: "flex-column gap-1",
    sm: "flex-row gap-1"
};
export const SETTINGS_WINDOW_BODY_EMPTY_SPACE_WHEN_NO_INFO = {
    xs: false,
    md: true
};

export const SETTINGS_WINDOW_FOOTER_FULL_WIDTH = {
    xs: true,
    sm: false
};
export const SETTINGS_WINDOW_FOOTER_LAYOUT_CLASS = {
    xs: 'flex-column',
    sm: 'flex-row'
};

// #endregion Settings window constants

// #region Loading bar constants

export const LOADING_BAR_WIDTH = '80%';

// #endregion Loading bar constants

// #region ConfirmPopup constants

export const CONFIRM_POPUP_WIDTH_STYLE = {
    xs: {
        minWidth: '12.5rem',
        maxWidth: '90%'
    },
    sm: {
        minWidth: '21.875rem',
        maxWidth: '75%'
    }
};

// #endregion

// #region Icon sizes

export const DEVICE_ITEM_ICON_SIZE = '1.5rem';
export const ORDER_LAYOUT_SELECTOR_ICON_SIZE = '1.25rem';

// #endregion Icon sizes